<template>
    <div class="widget" :class="style">
        <div ref="widget_container" class="container">
            <div class="header">{{ title || 'Атрибут title указан'}}</div>
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Widget",
    props: ["title"],
    data() {
        return {
            width: 0,
            height: 0,
            min_desktop_width: 500,
        };
    },

    mounted() {
        this.refresh_sizes();
        window.onresize = this.refresh_sizes;
    },

    computed: {
        style() {
            if (this.width > this.min_desktop_width) return "desktop";
            return "mobile";
        },
    },

    methods: {
        refresh_sizes() {
            if (this.$refs.widget_container) {
                this.width = this.$refs.widget_container.clientWidth;
                this.height = this.$refs.widget_container.clientHeight;
                let tmp = {
                    width: this.width,
                    height: this.height,
                    style: this.style,
                };
                this.$emit("resize", tmp);
            }
        },
    },
};
</script>

<style scoped>
/* стиль элемента-обертки для удобного встраивания виджета на страницу */
.widget {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
}

/* основной элемент виджета  - его пользователь и видит*/
.widget > .container {
    margin: auto;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    max-width: 800px;
    min-height: 685px;

    background: white;
    box-shadow: 0px 0px 3px black;
    border-radius: 5px;
    padding: 15px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
}
.widget.mobile > .container {
    min-height: 730px;
    padding: 0px;
}

.widget > .container > .header {
    flex-grow: 0;
    font-weight: bold;
    font-size: 14pt;
    text-align: center;
    border-bottom: 1px dashed #fc5a0a;
    padding-bottom: 15px;
    margin: 10px;
    margin-bottom: 5px;
    color: black;
    width: auto;
}

.widget.mobile > .container > .header {
    font-size: 14pt;
    padding-bottom: 5px;
    margin: 10px;
    margin-bottom: 0px;
}

.widget > .container > .content {
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    overflow: hidden;
    /* position: relative; */
}


</style>

<style>

/* стили общие для всего содержимого виджета */
.hidden {
    display: none !important;
}


.widget .ellipsis {
    overflow: hidden;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.widget .field {
    color: #666;
    color: black;
    padding: 6px;
    font-size: 1rem;
    display: block;
    background: #fafafa;
    transition: all 0.2s linear;
    border: 1px solid lightgray;
    flex-grow: 1;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;
    display: block;
}

.widget .field.short {
    margin-right: 23px;
}

.widget .required {
    border-color: red;
    border-style: dashed;
}

.widget .disabled {
    color: grey;
}

.widget hr {
    border: 0.5px solid #fc5a0a;
    width: 80%;
    margin: 3px auto;
    padding: 0px;
}

.widget .noselect {
    /* запрет выделения текста мышкой */
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>
